
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component({
  components: {
    Select
  }
})
export default class InventoryItemStatusSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop({ default: false })
  inWarehouseOnly: boolean;

  get options() {
    if(this.inWarehouseOnly)
    {
      return barcodeSystemModule.inventoryItemStatuses.filter(x => x.isInWarehouse).map(x => ({ label: x.description, value: x.code }));
    }
    else
    {
      return barcodeSystemModule.inventoryItemStatuses.map(x => ({ label: x.description, value: x.code }));
    }  
  }
}
